function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
var _excluded = ["className", "disabled", "error", "focused", "look", "readOnly"],
  _excluded2 = ["look"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { forwardRef, useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import "../../../enums/accordion.js";
import "../../../enums/alert.js";
import "../../../enums/avatar.js";
import "../../../enums/breakpoints.js";
import "../../../enums/button.js";
import "../../../enums/code-editor.js";
import "../../../enums/colors.js";
import "../../../enums/combobox.js";
import "../../../enums/date.js";
import "../../../enums/drag-and-drop.js";
import "../../../enums/dialog.js";
import "../../../enums/divider.js";
import "../../../enums/dropdown.js";
import "../../../enums/fieldset.js";
import "../../../enums/font-icon.js";
import "../../../enums/fonts.js";
import "../../../enums/headings.js";
import { InputLooks } from "../../../enums/input.js";
import "../../../enums/keys.js";
import "../../../enums/list.js";
import "../../../enums/listbox.js";
import "../../../enums/loader.js";
import "../../../enums/margin.js";
import "../../../enums/option.js";
import "../../../enums/pill.js";
import "../../../enums/placements.js";
import "../../../enums/popout.js";
import "../../../enums/privacy.js";
import "../../../enums/radio-group.js";
import "../../../enums/status.js";
import "../../../enums/switch.js";
import "../../../enums/table.js";
import "../../../enums/tooltip.js";
import "../../../enums/transitions.js";
import "../../../enums/widths.js";
import "../../../styles/styled-components/alert.js";
import "../../../styles/styled-components/animations.js";
import "../../../styles/styled-components/box-shadow.js";
import "../../../styles/styled-components/button.js";
import "../../../themes/alert.js";
import "../../../themes/button.js";
import "../../../themes/checkbox.js";
import "../../../themes/divider.js";
import "../../../themes/dropdown.js";
import "../../../themes/fieldset.js";
import "../../../themes/input.js";
import "../../../themes/list.js";
import "../../../themes/listbox.js";
import "../../../themes/loader.js";
import "../../../themes/option.js";
import "../../../themes/popout.js";
import "../../../themes/switch.js";
import { lightTheme } from "../../../themes/themes.js";
import "../../../themes/tooltip.js";
import "../../../styles/styled-components/font-face.js";
import "../../../styles/styled-components/global.js";
import { baseInputStyle, getInputBorderRadius, getInputPadding, getInputTheme, getInputFocusedBorderColor } from "../../../styles/styled-components/input.js";
import "../../../styles/styled-components/list.js";
import "../../../styles/styled-components/listitem.js";
import "../../../styles/styled-components/media-queries.js";
import "../../../styles/styled-components/reset.js";
import "../../../styles/styled-components/outline.js";
import "../../../styles/styled-components/popout.js";
import "../../../styles/styled-components/screen-reader.js";
import "../../../styles/styled-components/switch.js";
import "../../../styles/styled-components/tooltip.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var BaseFakeTextarea = /*#__PURE__*/forwardRef(function (props, ref) {
  var _classnames;
  var className = props.className,
    disabled = props.disabled,
    error = props.error,
    focused = props.focused,
    look = props.look,
    readOnly = props.readOnly,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
    "aria-disabled": disabled,
    "aria-readonly": readOnly,
    className: classnames((_classnames = {
      'bf-textarea__fake': true,
      'bf-textarea__fake--error': !!error,
      'bf-textarea__fake--disabled': disabled,
      'bf-textarea__fake--focused': focused
    }, _defineProperty(_classnames, "bf-textarea__fake--".concat(look), look), _defineProperty(_classnames, 'bf-textarea__fake--readonly', readOnly), _defineProperty(_classnames, "".concat(className), !!className), _classnames)),
    ref: ref
  }));
});
var Textarea = styled(BaseFakeTextarea)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  cursor: ", ";\n\n  &.bf-textarea__fake--focused {\n    ", "\n  }\n"])), baseInputStyle, getInputBorderRadius({}), getInputPadding({}), function (_ref) {
  var error = _ref.error,
    look = _ref.look;
  return getInputTheme({
    error: error,
    look: look
  });
}, function (_ref2) {
  var disabled = _ref2.disabled,
    readOnly = _ref2.readOnly;
  return !disabled && !readOnly ? 'pointer' : 'default';
}, function (_ref3) {
  var disabled = _ref3.disabled,
    error = _ref3.error,
    look = _ref3.look;
  return getInputFocusedBorderColor({
    disabled: disabled,
    error: error,
    look: look
  });
});
/**
 * A `<div>` that is styled to look like `<StandardTextarea>` to hold things like `<StandardPill>`.
 *
 * When `InputLabelPositions.Left`is set, it is recommended to set a `width` or `max-width` on `.bf-textfield__header`.
 *
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/textarea
 *
 * @param props FakeTextareaProps
 * @returns FunctionComponent<FakeTextareaProps>
 */
var FakeTextarea = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$look = props.look,
    look = _props$look === void 0 ? InputLooks.Default : _props$look,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, /*#__PURE__*/React.createElement(Textarea, _extends({}, otherProps, {
    look: look,
    ref: ref
  })));
});
export { FakeTextarea };